import * as React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import { ChevronLeftIconLarge } from "../icons/ChevronIcons";

interface Props {
  onClick: () => void;
  disabled?: boolean;
  color?: string;
  medium?: boolean;
}

const ButtonContainer = styled.button<{ color?: string; medium?: boolean }>`
  width: ${(props) => (props.medium ? "36px" : "48px")};
  height: ${(props) => (props.medium ? "36px" : "48px")};
  border-radius: 50%;
  background-color: ${(props) => props.color ?? theme.colors.info20};
  outline: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    filter: opacity(0.6);
    box-shadow: ${theme.shadow.cardShadow};
  }

  &:active {
    box-shadow: none;
  }
`;

const BackButton: React.FC<Props> = ({
  onClick,
  disabled,
  color,
  medium = true,
}) => {
  return (
    <ButtonContainer
      onClick={onClick}
      disabled={disabled}
      color={color}
      medium={medium}
    >
      <ChevronLeftIconLarge />
    </ButtonContainer>
  );
};

export default BackButton;
